import React, { FC } from "react";

import { Layout } from "../../components";
import { Box, Button, Center } from "../../components/ui";
import WoWSvg from "../../resources/images/v16_131.png";

import styles from "./index.module.css";

const WelcomePage: FC = () => {
  return (
    <Layout>
      <Center>
        <div className={styles.container}>
          <Box className={styles.box}>
            <div className={styles.imageContainer}>
              <img src={WoWSvg} className={styles.image} alt="" />
            </div>
            <div className={styles.textContainer}>
              <p className={`${styles.paragraph} ${styles.firstParagraph}`}>
                Приветствуем! Здесь вы можете управлять своими медиапакетами.
              </p>
              <p className={styles.paragraph}>
                Для доступа к полному функционалу сайта рекомендуем
                зарегистрироваться.
              </p>
            </div>
            <div className={styles.buttonContainer}>
              <div className={styles.registerButtonContainer}>
                <Button
                  label="Зарегистрироваться"
                  type="button"
                  variant="fill"
                  size="large"
                  height={15}
                  padding={23}
                  isFullWidth
                />
              </div>
              <div className={styles.continueButtonContainer}>
                <Button
                  label={`Продолжить \r\n с временным аккаунтом`}
                  type="button"
                  height={7}
                  isFullWidth
                  variant="outlined"
                />
              </div>
            </div>
            <div className={styles.reminderText}>
              Напоминаем, что сейчас у вас временный аккаунт. Срок хранения
              ваших ваших ваших ваших медиапакетов ограничен.
            </div>
          </Box>
        </div>
      </Center>
    </Layout>
  );
};

export default WelcomePage;
